import { Box, Typography } from '@material-ui/core';
import React from 'react';
import { FC } from 'react';
import {
  email,
  minLength,
  regex,
  required,
  SelectInput,
  TextInput,
} from 'react-admin';
import { countries } from '../../helpers/country';
import { parsePhone } from '../../helpers/parsePhone';
import './index.css';

interface Props {
  isBlocked: boolean;
  changeStatus: () => void;
  isShow: boolean;
}

interface SelectCountries {
  id: string;
  name: string;
}

const UserGeneralTab: FC<Props> = ({ isBlocked, changeStatus, isShow }) => {
  countries.sort();
  const countryObject = (countries: Array<string>) => {
    let result = countries.reduce((agg, item, i) => {
      agg.push({ id: item, name: item });
      return agg;
    }, Array<SelectCountries>());
    return result;
  };

  return (
    <>
      <div className='user-profile-container'>
        <Box
          display='flex'
          justifyContent='flex-start'
          alignItems='center'
          width='50%'
        >
          <Typography gutterBottom className='base-color'>
            First Name
          </Typography>
          <TextInput
            id='user-general-input'
            source='name'
            disabled={isShow}
            fullWidth
            className='input-form'
            label=''
          />
        </Box>

        <Box
          display='flex'
          justifyContent='flex-start'
          alignItems='center'
          width='50%'
        >
          <Typography gutterBottom className='base-color'>
            Last Name
          </Typography>
          <TextInput
            id='user-general-input'
            source='surname'
            disabled={isShow}
            fullWidth
            className='input-form'
            label=''
          />
        </Box>

        <Box
          display='flex'
          justifyContent='flex-start'
          alignItems='center'
          width='50%'
        >
          <Typography className='base-color'>Email address</Typography>
          <TextInput
            id='user-general-input'
            source='email'
            disabled={isShow}
            fullWidth
            className='input-form'
            label=''
          />
        </Box>

        <Box
          display='flex'
          justifyContent='flex-start'
          alignItems='center'
          width='50%'
        >
          <Typography className='base-color'>Phone</Typography>
          <TextInput
            id='user-general-input'
            source='phone'
            disabled={isShow}
            fullWidth
            className='input-form'
            name='phone'
            label=''
            format={(value) => parsePhone(value)}
            parse={(value) => parsePhone(value)}
          />
        </Box>

        <Box
          display='flex'
          justifyContent='flex-start'
          alignItems='center'
          width='50%'
          marginBottom='1em'
        >
          <Typography className='base-color'>Country</Typography>
          <SelectInput
            id='search-input'
            defaultValue={'UK'}
            source='country'
            choices={countryObject(countries)}
            className='input-form'
            label=''
            disabled={isShow}
          />
        </Box>
        <Box
          display='flex'
          justifyContent='flex-start'
          alignItems='center'
          width='50%'
          marginBottom='2em'
        >
          <Typography className='base-color'>Status</Typography>
          <label className='switch checkbox-margin'>
            <input
              disabled={isShow}
              type='checkbox'
              checked={!isBlocked}
              onChange={changeStatus}
            />
            <span className='slider round'></span>
          </label>
        </Box>
      </div>
    </>
  );
};

export default UserGeneralTab;
